export default {"src":"/_next/static/media/google_play_logo.6857d1f9.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};